import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, ContainerForm, CustomButton, Form, Label } from "./styles";
import Input from "../../components/Input";
import useAuth from "../../hooks/useAuth";

const Login = () => {
  const { verificarAutenticacao } = useAuth();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, senha }),
      });

      const data = await res.json();

      if (res.ok && data.sucesso) {
        await verificarAutenticacao();
        navigate("/dashboard");
      } else {
        setErro(data.erro || "E-mail ou senha incorretos");
      }
    } catch (error) {
      setErro("Erro de conexão com o servidor");
    }
  };

  return (
    <Container>
      <h2>Acesse sua conta</h2>
      <p>Informe seu email e senha</p>
      <ContainerForm>
        <Form onSubmit={handleLogin}>
          <Label>E-mail</Label>
          <Input
            type="text"
            placeholder="Informe seu email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Label>Senha</Label>
          <Input
            type="password"
            placeholder="Informe sua senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />

          <CustomButton type="submit">Acessar</CustomButton>

          {erro && <p style={{ color: "red" }}>{erro}</p>}
        </Form>
      </ContainerForm>
    </Container>
  );
};

export default Login;